module.exports = __webpack_public_path__ + "static/media/ic_general_communications.11ef8687.svg";